import { ReturnsAndClaimsPermissions } from "@redotech/redo-model/permissions";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { folderTypes } from "@redotech/redo-model/views/folders";
import { RecycleView } from "@redotech/redo-model/views/views";
import { ReactNode, createContext, memo } from "react";
import { useViewsAndFolders } from "../hooks/use-views-and-folders";

export const RecycleViewsContext = createContext<
  | {
      teamViews?: RecycleView[];
      folders?: folderTypes["recycle"][];
      reloadViews?: () => Promise<void>;
    }
  | undefined
>(undefined);

export const ReloadRecycleViewsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const RecycleViewsProvider = memo(function RecycleViewsProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { views, folders, reloadViews } = useViewsAndFolders<
    RecycleView,
    folderTypes["recycle"],
    ReturnTypeEnum.RECYCLE
  >(
    ReturnTypeEnum.RECYCLE,
    ReturnsAndClaimsPermissions.MANAGE_RECYCLING_REQUESTS,
  );

  return (
    <RecycleViewsContext.Provider
      value={{ teamViews: views, folders, reloadViews }}
    >
      <ReloadRecycleViewsContext.Provider value={reloadViews}>
        {children}
      </ReloadRecycleViewsContext.Provider>
    </RecycleViewsContext.Provider>
  );
});
